
const createHistory = require('history').createHashHistory;
const history = createHistory();
Object.assign(history, {
  go: to => {
    window.navigateV6 ? window.navigateV6(to) : history.go(to);
  },
  push: (to, options) => {
    const push = window.navigateV6 || history.push;
    push(to, options);
  },
  replace: (to, options) => {
    const replace = window.navigateV6 || history.replace;
    replace(to, { ...options, replace: true });
  },
  goBack: () => {
    window.navigateV6 ? window.navigateV6(-1) : history.back();
  },
  queryParams:{
    query:{}
  }
})

export default history;
